// helpers/rutaCamiones.js
import axios from "axios";

const RAW_BASE_URL =
  import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- CAMIONES / VEHÍCULOS / MAQUINARIA ----

export const getCamiones = async () => {
  const { data } = await API.get(p("camiones"), auth());
  return data;
};

export const getCamionById = async (id) => {
  const { data } = await API.get(p(`camiones/${id}`), auth());
  return data;
};

export const postCamion = async (payload) => {
  const { data } = await API.post(p("camiones"), payload, auth());
  return data;
};

export const putCamion = async (id, payload) => {
  const { data } = await API.put(p(`camiones/${id}`), payload, auth());
  return data;
};

export const deleteCamion = async (id) => {
  const { data } = await API.delete(p(`camiones/${id}`), auth());
  return data;
};